import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirmation-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.showToggleDialog,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showToggleDialog) = $event)),
    style: { width: '450px' },
    header: _ctx.t('offline.toggleTitle'),
    modal: true,
    closable: false
  }, {
    footer: _withCtx(() => [
      (_ctx.networkState === 'online')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.setOffline'),
              icon: "pi pi-ban",
              class: "p-button-primary mr-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOfflineState('offline')))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.stayOnline'),
              icon: "pi pi-wifi",
              class: "p-button-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
            }, null, 8, ["label"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.setOnline'),
              icon: "pi pi-wifi",
              class: "p-button-primary mr-4",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOfflineState('online')))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.stayOffline'),
              icon: "pi pi-ban",
              class: "p-button-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog()))
            }, null, 8, ["label"])
          ]))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.networkState === "online" ? _ctx.t("offline.offlineDetected") : _ctx.t("offline.onlineDetected")), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}